<!-- pharmacy code-->
<div class="container flex-grow-1">
  <div class="form-row">
    <div class="col-md-12 col-lg-6">

      <div class="form-group mb-4 border-bottom search-pharm">
        <label class="form-label padding-left fw-bold"> {{'updateinfo.pharmacy'|translate}}</label>
        <div class="dropdown input-icon search" ngbDropdown #pharmacyDrop="ngbDropdown">
          <input placeholder="{{'updateinfo.pharmacy_search'|translate}}" class="form-control text-left border-0 ltr-component" type="text"
                 ngbDropdownAnchor (focus)="pharmacyDrop.open()" id="searchpharmacydropdown" aria-haspopup="true" aria-expanded="false"
                 [(ngModel)]="pharmaciesSearch"
                 (input)="ValidateAddress($event.target)" (keyup)="SearchPharmacyList($event)">

          <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchpharmacydropdown" [ngClass]="{'d-none': dNonePharmacy}">

            <button ngbDropdownItem *ngIf="isLoading">
              {{'updateinfo.pharmacy_loading'|translate}}
            </button>
            <button ngbDropdownItem *ngIf="isShowplaceholder">
              {{'updateinfo.pharmacy_search'|translate}}
            </button>
            <button *ngIf="filterSearchPharmaciesList?.length === 0 && !isLoading" ngbDropdownItem>
              {{'updateinfo.pharmacy_no_records_found'|translate}}
            </button>
            <button ngbDropdownItem *ngFor="let pharmacy of filterSearchPharmaciesList"
                    (click)="SetPharmaciesList(pharmacy)">

              <h6 class="mb-1 font-weight-bold text-capitalize">{{pharmacy.pharmacyName | lowercase}}</h6>
              <span class="text-capitalize">{{pharmacy.pharmacyAddress | lowercase}}</span> <br>
              <span class="text-capitalize">{{pharmacy.pharmacyCity | lowercase}}, {{pharmacy.pharmacyState}} {{pharmacy.pharmacyZip.substring(0, 5)}}</span> <br>
              <span>{{pharmacy.pharmacyPhone}}</span>

            </button>


          </div>
        </div>



      </div>
      <div class="d-flex flex-wrap select-list-pharmacy text-capitalize">
        <div *ngIf="Getpharmacies[0]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p1" class="select-item-pharmacy mb-4" style="width: 100%;align-items: flex-start !important;">
          <!--<span id="race1" style="width:80%"><strong>{{Getpharmacies[0].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[0].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[0].PHARMACY_STATE | uppercase}} {{Getpharmacies[0].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[0].PHARMACY_PHONE}}</span>-->
          <div id="race1" style="width:80%">
            <strong>{{Getpharmacies[0].PHARMACY_NAME | lowercase}}</strong>
            <div class="mt-2">
              {{Getpharmacies[0].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[0].PHARMACY_STATE | uppercase}} {{Getpharmacies[0].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>
              {{Getpharmacies[0].PHARMACY_PHONE}}
            </div>
          </div>
          <a (click)="RemovePharmacyData('0')" class="text-dark">{{'button.delete'|translate}}</a>
          <ng-template #p1>
            <div class="p-2">
              <b>{{Getpharmacies[0].PHARMACY_NAME | titlecase}}</b><br>
              <p>{{Getpharmacies[0].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[0].PHARMACY_STATE | uppercase}} {{Getpharmacies[0].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[0].PHARMACY_PHONE}}</p>
            </div>
          </ng-template>
        </div>
        <div *ngIf="Getpharmacies[1]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p2" class="select-item-pharmacy mb-4" style="width: 100%;align-items: flex-start !important;">
          <!--<span id="race2" style="width:80%"><strong>{{Getpharmacies[1].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[1].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[1].PHARMACY_STATE | uppercase}} {{Getpharmacies[1].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[1].PHARMACY_PHONE}}</span>-->
          <div id="race2" style="width:80%">
            <strong>{{Getpharmacies[1].PHARMACY_NAME | lowercase}}</strong>
            <div class="mt-2">
              {{Getpharmacies[1].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[1].PHARMACY_STATE | uppercase}} {{Getpharmacies[1].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>
              {{Getpharmacies[1].PHARMACY_PHONE}}
            </div>
          </div>
          <a (click)="RemovePharmacyData('1')" class="text-dark">{{'button.delete'|translate}}</a>
          <ng-template #p2>
            <div class="p-2">
              <b>{{Getpharmacies[1].PHARMACY_NAME | titlecase}}</b><br>
              <p>{{Getpharmacies[1].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[1].PHARMACY_STATE | uppercase}} {{Getpharmacies[1].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[1].PHARMACY_PHONE}}</p>
            </div>
          </ng-template>
        </div>
        <div *ngIf="Getpharmacies[2]" [triggers]="'mouseenter:mouseleave'" [placement]="'auto'" [autoClose]="true" [ngbPopover]="p3" class="select-item-pharmacy mb-4" style="width: 100%;align-items: flex-start !important;">
          <!--<span id="race2" style="width:80%"><strong>{{Getpharmacies[2].PHARMACY_NAME | lowercase}}</strong><br>{{Getpharmacies[2].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[2].PHARMACY_STATE | uppercase}} {{Getpharmacies[2].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[2].PHARMACY_PHONE}}</span>-->
          <div id="race3" style="width:80%">
            <strong>{{Getpharmacies[2].PHARMACY_NAME | lowercase}}</strong>
            <div class="mt-2">
              {{Getpharmacies[2].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[2].PHARMACY_STATE | uppercase}} {{Getpharmacies[2].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>
              {{Getpharmacies[2].PHARMACY_PHONE}}
            </div>
          </div>
          <a (click)="RemovePharmacyData('2')" class="text-dark">{{'button.delete'|translate}}</a>
          <ng-template #p3>
            <div class="p-2">
              <b>{{Getpharmacies[2].PHARMACY_NAME | titlecase}}</b><br>
              <p>{{Getpharmacies[2].PHARMACY_ADDRESS.trim() | titlecase}}, {{Getpharmacies[2].PHARMACY_STATE | uppercase}} {{Getpharmacies[2].PHARMACY_ZIP.substring(0, 5) | titlecase}}<br>{{Getpharmacies[2].PHARMACY_PHONE}}</p>
            </div>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="row justify-content-center allergy-card">
  <div class="col-6 col-sm-5 col-md-3" *ngIf="objPatientMedication.length == 0">
    <div class="bg-info card h-100 mb-3 p-3 text-center text-white" data-toggle="modal"
         (click)="onModalMedication(operationAdd)">
      <!--<span class="bg-white icon mb-3"><img height="25" src="../../../assets/images/Icons/plus.svg"></span>-->
      <span class="bg-white icon mb-3"><i class="fas fa-plus" style="color: #10469f;"></i></span>
      <h6 class="font-weight-normal mb-0">{{'medication.medication_add_medications'|translate}}</h6>
    </div>
  </div>
  <div class="col-6 col-sm-5 col-md-3" *ngIf="objPatientMedication.length == 0">
    <div class="card mb-3 h-100 p-3 text-center text-info" (click)="setNoKnownAlrgMedFam('medication')">
      <span class="icon mb-3"><img height="23" src="../../../assets/images/Icons/cross.svg"></span>
      <h6 class="font-weight-normal mb-0">{{'medication.medication_no_known_medications'|translate}}</h6>
    </div>
  </div>

  <!--<div class="col-12" *ngIf="objPatientMedication.length != 0">
    <button class="btn btn-primary btncare" style="float: right;" type="button"
            (click)="onModalMedication(operationAdd)">
      {{'button.add_medication'|translate}}
    </button>
  </div>-->

</div>

<ng-container *ngIf="!isLoadingPM">
  <ng-container *ngIf="objPatientMedication.length > 0 else notFoundPM">
    <div class="container flex-grow-1 overflow-auto">
      <div class="specialist-list">
        <div class="form-row">
          <div class="col-12 mb-4" *ngIf="objPatientMedication.length != 0">
            <button class="btn btn-primary btncare" style="float: right;" type="button"
                    (click)="onModalMedication(operationAdd)">
              {{'button.add_medication'|translate}}
            </button>
          </div>
          <div class="col-lg-6" *ngFor="let medication of objPatientMedication;">
            <div class="card mb-4 pb-3">
              <div class="card-body p-0">
                <div class="align-items-center d-flex justify-content-between mb-2" style="align-items: flex-start !important; ">
                  <h6 class="font-weight-bold mb-0">{{(medication.medicineName|titlecase) || 'N/A'}}</h6>
                  <div class="ctabtns d-flex"  *ngIf="medication.addedBy==='Patient'">
                    <a href="javascript:void(0)" *ngIf="medication.isActive ==='False' && medication.recounciledData==='0'"
                       (click)="onDeleteMedication(medication)" class="text-dark">
                      {{'link.delete'|translate}}

                    </a>
                  </div>

                  <!--<div class="ctabtns d-flex" style="align-items: flex-start !important; " *ngIf="medication.addedBy==='Provider'">

                    <a href="javascript:void(0)" (click)="onModalMedicationProvider('delete')" class="text-dark">
                      {{'link.delete'|translate}}
                    </a>
                  </div>-->

                </div>
                <div class="mb-2"
                     [ngStyle]="{'display' : intakeFieldsSetting.isIntakeAllowed ? '' : 'none'}">
                  <span>{{'medication.medication_intake'|translate}} </span>
                  <span class="text-muted font-weight-bold mr-1">{{(medication.sig |titlecase)|| 'N/A'}}</span>
                </div>
                <div class="mb-2"
                     [ngStyle]="{'display' : intakeFieldsSetting.isDiagnosisAllowed ? '' : 'none'}">
                  <span>{{'medication.medication_diagnosis'|translate}}: </span>
                  <span class="text-muted font-weight-bold mr-1">{{(medication.diagnosis |titlecase) || 'N/A'}}</span>
                </div>
                <div>
                  <span>{{'medication.medication_added_by'|translate}} </span>
                  <span *ngIf="medication.addedBy==='Patient'" class="text-muted font-weight-bold mr-1">
                    {{'medication.medication_added_by_me'|translate}}
                  </span>
                  <span *ngIf="medication.addedBy==='Provider'" class="text-muted font-weight-bold mr-1">
                    {{'medication.medication_provider'|translate}}
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #notFoundPM>

    <div class="col-12 mt-4 text-center px-0">
      <p class="mb-0 text-danger">{{'medication.medication_no_medications_history'|translate}}</p>
    </div>
  </ng-template>
</ng-container>

<!-- modals  -->
<!-- add  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse modal-full-height modal-tabs"
     id="Medical-History-Modal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'medication.medication_add_medications'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!--Add Medication List as Photo-->


        <div *ngIf="addNewMedication" class="row justify-content-center text-center">
          <div class="col-12">
            <p class="mt-3">{{'medication.medication_choose_preference'|translate}}</p>
            <button type="button" class="btn btn-primary btncare w-100 mt-3" onclick="document.getElementById('uploadMedicationList').click()">
              {{'medication.medication_take_photo'|translate}}
            </button>
            <input type="file" id="uploadMedicationList" style="display:none;" accept="image/png, image/gif, image/jpeg,image/jpg" (change)="fileChangeEvent($event)">
            <div class="devider mb-4">
              <span>{{'careteam.or'|translate}}</span>
            </div>

            <button type="button" class="btn btn-primary btncare w-100" (click)="AddMedicationManually()">
              {{'medication.medication_add_manually'|translate}}
            </button>
          </div>
        </div>


        <!--Show uploaded photo -->
        <!--<div *ngIf="isMedicatioListPhotoAdded" class="row justify-content-center align-item-center mt-5">
          <div class="col-md-12">

            <div class="text-center">
              <img [src]="defaultImage" accept=".gif,.jpg,.jpeg,.png" name="medicationPic" alt="Medication List" id="medicationPic" style="max-width: 300px; max-height: 200px;" />
            </div>

            <div class="text-center">
              <input type="file" id="retakeMedicationList" style="display:none" accept="image/png, image/gif, image/jpeg,image/jpg" (change)="fileChangeEvent($event)">
              <button type="button" class="btn btn-primary btn-lg mt-3" onclick="document.getElementById('retakeMedicationList').click()">
                {{'medication.medication_retake_photo'|translate}}
              </button>
            </div>

          </div>
        </div>-->

        <div *ngIf="isMedicatioListPhotoAdded" class="row text-center">
          <div class="col-md-12">
            <div *ngIf="previewUrls.length > 0">
              <div *ngFor="let url of previewUrls; let i = index" class="image-container">
                <div>
                  <div>
                    <img [src]="url" class="responsive-img" id="url">
                  </div>
                  <div style="margin-top: 25px;">
                    <button type="button" class="btn btn-primary btncare w-100" (click)="openFileInput(i)">
                      {{'medication.medication_retake_photo'|translate}}
                    </button>
                  </div>

                </div>
                <input type="file" id="retakeMedicationList_{{i}}" style="display:none " accept="image/png, image/gif, image/jpeg,image/jpg" (change)="retakePhoto(i, $event)">
              </div>
            </div>

            <!--<button type="button" class="btn btn-primary mr-3 mt-3" (click)="addPhotoInput()">{{'medication.add_another'|translate}}</button>-->

          </div>
        </div>

        <style>
          .cancel-icon {
            cursor: pointer;
            position: absolute;
            right: 0px;
            top: 10px;
            font-size: 18px;
            color: #52b0ba !important;
            background: white;
            padding-left: 10px;
            padding-right: 10px;
            float: right;
          }

            .cancel-icon:hover {
              color: #52b0ba !important; /* Change color on hover */
            }

          @media (max-width: 768px) {
            .cancel-icon {
              color: #52b0ba !important;
            }
          }
        </style>

        <!--Add Medication Manually-->
        <div *ngIf="addNewMedicationManually" class="insurance-tab">
          <div class="form-row">
            <div class="col-md-12">

              <div class="form-group">
                <div class="input-group mb-3 border-bottom">
                  <label class="form-label fw-bold">{{'medication.medication_medicine'|translate}}<span class="text-danger">*</span></label>
                  <div class="dropdown w-100" ngbDropdown
                       [ngClass]="(medicationDrop.isOpen() && selected_objPatientMedication.medicineName.length>0) ? '' : 'input-icon search'"
                       #medicationDrop="ngbDropdown">
                    <input placeholder="{{'medication.medication_search_medicine'|translate}}"
                           ngbDropdownAnchor
                           (focus)="medicationDrop.open()" id="medicationsearchdropdown"
                           class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                           aria-haspopup="true" aria-expanded="false"
                           (keyup)="GetPatientMedicationFromFD($event)"
                           [(ngModel)]="selected_objPatientMedication.medicineName">

                    <span *ngIf="medicationDrop.isOpen() && selected_objPatientMedication.medicineName.length > 0"
                          class="cancel-icon"
                          style="color: #52b0ba !important"
                          (click)="clearMedicineSearchInput(); medicationDrop.close()">

                      <i class="fas fa-times" style="color: #10469f;"></i>
                    </span>

                    <div ngbDropdownMenu class="custom-menu"
                         aria-labelledby="medicationsearchdropdown"
                         [ngClass]="{'d-none': dNonemedication}"
                         *ngIf="selected_objPatientMedication.medicineName.length > 0">
                      <!-- <ul class="list-unstyled symptoms-list mb-0"> -->
                      <button ngbDropdownItem *ngIf="isLoading">{{'medication.medication_loading'|translate}}</button>
                      <button ngbDropdownItem
                              *ngIf="filteredMedications?.length === 0 && selected_objPatientMedication.medicineName.length > 0 && !isLoading">
                        {{'medication.medication_no_records_found'|translate}}
                      </button>
                      <button ngbDropdownItem *ngFor="let list of filteredMedications"
                              (click)="(isFDServiceDataComing) ? SetMedicationForFD(list.medicine_trade) : SetMedication(list.MEDICINE_TRADE)">
                        <span>{{ isFDServiceDataComing ? list.medicine_trade : list.MEDICINE_TRADE }}</span><br />


                        <!--<span *ngIf="list.GENERIC_DESCRIPTION!='NULL'">{{list.GENERIC_DESCRIPTION}}</span>-->
                      </button>
                      <!-- </ul> -->
                    </div>


                  </div>
                </div>
                <p *ngIf="medicError" class="err">{{medicError}}</p>
              </div>

            </div>
            <!--<div class="col-md-12"
                 [ngStyle]="{'display': intakeFieldsSetting.isIntakeAllowed ? '' : 'none' }">
              <div class="form-group border-bottom">
                <label class="form-label fw-bold">{{'medication.medication_sig'|translate}}</label>
                <input placeholder="{{'medication.medication_how_often_you_take_this_medicine'|translate}}" maxlength="50"
                       class="form-control border-0" id="sig" tabindex="15" type="text"
                       [(ngModel)]="selected_objPatientMedication.sig" name="sig" />

              </div>
            </div>-->
            <!--Sig dropdown start-->
            <div class="col-md-12"
                 [ngStyle]="{'display': intakeFieldsSetting.isIntakeAllowed ? '' : 'none' }">
              <div class="form-group has-search form-select mb-4 border-bottom">
                <label class="form-label fw-bold">{{'medication.medication_sig'|translate}}</label>

                <select class="form-control border-0 "
                        id="sig"
                        tabindex="15"
                        [(ngModel)]="selected_objPatientMedication.sig"
                        name="sig">

                  <option value="" disabled selected>{{'medication.medication_how_often_you_take_this_medicine'|translate}}</option>

                  <option *ngIf="isSigLoading" disabled>{{'medication.medication_loading'| translate}}</option>

                  <option class="err text-center" *ngIf="!isSigLoading && sigList.length == 0 && !sigLoaded" disabled>
                    {{'medication.medication_no_records_found'| translate}}
                  </option>
                  <ng-container *ngIf="!isSigLoading && sigList.length > 0">
                    <option *ngFor="let s of sigList" [value]="s.sig || s.SIG || s.description">
                      {{ s.sig || s.SIG || s.description }}
                    </option>
                  </ng-container>

                    <ng-container *ngIf="!isSigLoading && sigList.length == 0 && sigLoaded">
                      <option>{{'medication.medication_sig_take_1_capsule_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_1_capsule_twice_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_1_tablet_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_1_tablet_four_times_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_1_tablet_three_times_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_1_tablet_twice_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_2_tablets_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_take_2_tablets_twice_daily' | translate}}</option>
                      <option>{{'medication.medication_sig_apply_topically_as_needed' | translate}}</option>
                      <option>{{'medication.medication_sig_take_as_needed_for_nausea' | translate}}</option>
                      <option>{{'medication.medication_sig_take_as_needed_for_pain' | translate}}</option>
                      <option>{{'medication.medication_sig_take_before_bedtime' | translate}}</option>
                      <option>{{'medication.medication_sig_chew_thoroughly_before_swallowing' | translate}}</option>
                      <option>{{'medication.medication_sig_dissolve_under_tongue_as_needed' | translate}}</option>
                      <option>{{'medication.medication_sig_do_not_crush_or_chew' | translate}}</option>
                      <option>{{'medication.medication_sig_take_on_empty_stomach' | translate}}</option>
                      <option>{{'medication.medication_sig_take_every_4_hours_as_needed' | translate}}</option>
                      <option>{{'medication.medication_sig_take_every_6_hours_as_needed' | translate}}</option>
                      <option>{{'medication.medication_sig_take_every_8_hours_as_needed' | translate}}</option>
                      <option>{{'medication.medication_sig_take_every_12_hours' | translate}}</option>
                      <option>{{'medication.medication_sig_take_in_the_morning' | translate}}</option>
                      <option>{{'medication.medication_sig_take_with_food' | translate}}</option>
                      <option>{{'medication.medication_sig_take_with_meals' | translate}}</option>
                      <option>{{'medication.medication_sig_take_with_plenty_of_water' | translate}}</option>
                    </ng-container>
                </select>

              </div>
            </div>


            <!-- Common disease -->
            <!--<div class="form-group col-md-12">
              <div class="has-search form-select border-bottom">
                <label class="form-label fw-bold">{{'medication.medication_diagnosis' | translate}}</label>
                <select name="commondisease" id="commonDisease"
                        class="form-control border-0"
                        (change)="onChangeDisease($event)">
                  <option value="">Select Diagnosis</option>
                  <option *ngFor="let d of commonDisease;" [value]="d.diseaseId">
                    {{d.diseaseDescription}}
                  </option>
                </select>
              </div>
            </div>-->


            <div class="col-md-12"
                 [ngStyle]="{'display': intakeFieldsSetting.isDiagnosisAllowed ? '' : 'none' }">

              <div class="input-group mb-3 border-bottom">
                <label class="form-label fw-bold">{{'medication.medication_diagnosis' | translate}}</label>
                <div class="dropdown w-100" ngbDropdown
                     [ngClass]="(diagnosisDrop.isOpen() && selected_objPatientMedication.diagnosis.length > 0) ? '' : 'input-icon search'"
                     #diagnosisDrop="ngbDropdown">

                  <input placeholder="{{'medication.medication_search_diagnosis' | translate}}" ngbDropdownAnchor
                         (focus)="diagnosisDrop.open()" id="searchdiagnosisdropdown"
                         class="form-control text-left text-capitalize border-0 ltr-component" type="text" aria-haspopup="true"
                         aria-expanded="false" (keyup)="GetSolarApiDiagonsis($event)"
                         [(ngModel)]="selected_objPatientMedication.diagnosis">

                  <!--Cancel Icon for Diagnosis Input-->
                  <span *ngIf="diagnosisDrop.isOpen() && selected_objPatientMedication.diagnosis.length > 0"
                        class="cancel-icon"
                        style="color: #52b0ba !important"
                        (click)="clearDiagnosisInput(); diagnosisDrop.close()">
                    <i class="fas fa-times" style="color: #10469f;"></i>
                  </span>

                  <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchdiagnosisdropdown"
                       [ngClass]="{'d-none': dNonediagnosis}"
                       *ngIf="selected_objPatientMedication.diagnosis.length > 0">
                    <button ngbDropdownItem *ngIf="isLoading">
                      <span>{{'medication.medication_loading' | translate}}</span>
                    </button>
                    <button ngbDropdownItem
                            *ngIf="filteredDiagonosis?.length === 0 && selected_objPatientMedication.diagnosis.length > 0 && !isLoading">
                      {{'medication.medication_no_records_found' | translate}}
                    </button>
                    <button ngbDropdownItem *ngFor="let items of filteredDiagonosis"
                            (click)="SetDiagonosis(items.ICD10_DESCRIPTION)">
                      {{items.ICD10_DESCRIPTION}}
                    </button>
                  </div>
                </div>
              </div>


              <!--<p *ngIf="medicError" class="err">{{medicError}}</p>-->
            </div>




            <div class="container">
              <div class="row justify-content-between">
                <div class="col-12">
                  <button class="btn btn-primary btncare w-100" type="button" (click)="onlysaveMedication()">{{'button.save'|translate}}</button>
                  <div class="devider mb-4">
                    <span>{{'careteam.or'|translate}}</span>
                  </div>
                  <button class="btn btn-primary btncare w-100" type="button" (click)="AddanotherMedication()">{{'button.Save_add_more'|translate}}</button>
                </div>
              </div>

            </div>






            <!--<div class="container">
              <div class="row justify-content-between">
                <div class="col-lg-6 col-md-6 col-12 mb-2 mt-3">
                  <button class="btn btn-primary btncare w-100" type="button" (click)="onlysaveMedication()">{{'button.save'|translate}}</button>
                </div>
                <div class="col-lg-6 col-md-6 col-12 mb-2 mt-3">
                  <button class="btn btn-primary btncare w-100" type="button" (click)="AddanotherMedication()">{{'button.Save_add_more'|translate}}</button>
                </div>
              </div>
            </div>-->

          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button *ngIf="addNewMedication" type="button" class="btn btn-outline-primary " data-dismiss="modal">{{'button.close'|translate}}</button>
        <button *ngIf="!addNewMedication" type="button" class="btn btn-outline-primary " data-dismiss="modal" (click)="goBackToAddMedication()">{{'button.cancel'|translate}}</button>
        <!--<button *ngIf="!addNewMedication" type="button" (click)="isFromSaveMore=false;OnMedicationSubmit()" class="btn btn-primary ">{{'button.save'|translate}}</button>-->
        <button *ngIf="isMedicatioListPhotoAdded" type="button" (click)="OnMedicationSubmit()" class="btn btn-primary ">{{'button.save'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delete-medication">


  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'medication.medication_are_you_sure_you_want_to_delete_medication'|translate}}</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeDeleteAllergyModel">
          {{'button.cancel'|translate}}
        </button>
        <button type="button" id="closeDeleteFamilyHistory" (click)="onConfirmDeleteMedication()"
                class="btn btn-primary rbtn">
          {{'button.delete'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="successallergynoknown">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-success"><strong>{{'medication.medication_success'|translate}}</strong></h5>
        <p>{{'medication.medication_no'|translate}} {{noKnownDate}} {{'medication.medication_is_set'|translate}}</p>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeDeleteAllergyModel">
          {{'button.cancel'|translate}}
        </button>
        <button type="button" id="closeDeleteFamilyHistory" class="btn btn-primary ">{{'button.ok'|translate}}</button>
      </div>
    </div>
  </div>

</div>
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="addMore-medication">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Do you want to add another medication?</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closeAddmoreAllergyModel" (click)="AddanotherMedication()">
          {{'button.yes'|translate}}
        </button>
        <button type="button" id="closeDeleteFamilyHistory" data-dismiss="modal"
                class="btn btn-primary " (click)="CloseMedicationModal()">
          {{'button.no'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
